import script from "./CardAccountGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardAccountGroup.vue?vue&type=script&setup=true&lang=ts"

import "./CardAccountGroup.vue?vue&type=style&index=0&id=1fcad704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcad704"]])

export default __exports__